/**
 * Capacitor Preferences adapter (R8.2).
 *
 * @capacitor/preferences uses SharedPreferences on Android, UserDefaults on iOS,
 * and localStorage on web. Safe to call on all platforms without a native guard.
 *
 * Used for non-sensitive UI preferences (push enabled/disabled, stored deviceId).
 * For sensitive tokens (auth) continue using SecureStorage.
 */

import { Preferences } from '@capacitor/preferences';

export const AppPreferences = {
  async get(key: string): Promise<string | null> {
    const { value } = await Preferences.get({ key });
    return value;
  },

  async set(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value });
  },

  async remove(key: string): Promise<void> {
    await Preferences.remove({ key });
  },
};
